import {
  DISPLAY,
  LABEL_CLS,
  SURFACE_DARK,
  mix,
} from "@/components/editorial";
import { Check } from "lucide-react";

export type SliderFeature = {
  title: string;
  detail: string;
};

export function PricingSliderShell({
  eyebrow,
  title,
  description,
  value,
  featuresLabel,
  features,
  children,
}: {
  eyebrow: string;
  title: string;
  description: string;
  value: string;
  featuresLabel: string;
  features: readonly SliderFeature[];
  children: React.ReactNode;
}) {
  return (
    <div
      className="border p-6 md:p-8 lg:p-10"
      style={{ borderColor: mix("--theme-ink", 18) }}
    >
      <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-2xl">
          <p className={LABEL_CLS} style={{ color: "var(--theme-accent-text)" }}>
            {eyebrow}
          </p>
          <h3
            className="mt-4 text-[1.6rem] font-semibold tracking-[-0.02em]"
            style={DISPLAY}
          >
            {title}
          </h3>
          <p
            className="mt-2 text-[0.9rem] leading-[1.55]"
            style={{ color: mix("--theme-ink", 72) }}
          >
            {description}
          </p>
        </div>
        <p
          className="shrink-0 text-[1.15rem] font-semibold sm:text-right"
          style={DISPLAY}
        >
          {value}
        </p>
      </div>

      <div className="mt-9 grid gap-8 lg:grid-cols-[minmax(0,1.45fr)_minmax(19rem,0.75fr)] lg:gap-12">
        <div className="self-center">{children}</div>
        <div
          className="border-t pt-6 lg:border-t-0 lg:border-l lg:pt-0 lg:pl-10"
          style={{ borderColor: mix("--theme-ink", 16) }}
        >
          <p className={LABEL_CLS} style={{ color: mix("--theme-ink", 66) }}>
            {featuresLabel}
          </p>
          <ul className="mt-5 grid gap-5 sm:grid-cols-3 lg:grid-cols-1">
            {features.map((feature) => (
              <li key={feature.title} className="flex items-start gap-3">
                <Check
                  aria-hidden="true"
                  className="mt-0.5 size-4 shrink-0"
                  style={{ color: SURFACE_DARK }}
                />
                <div>
                  <p className="text-[0.84rem] font-semibold leading-[1.35]">
                    {feature.title}
                  </p>
                  <p
                    className="mt-1 text-[0.76rem] leading-[1.45]"
                    style={{ color: mix("--theme-ink", 66) }}
                  >
                    {feature.detail}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
